import React, { useMemo } from 'react';
import { CardBody, Row } from 'reactstrap';
import { Colxx } from '../../components/common/CustomBootstrap';
import moment from 'moment';
import filter from 'lodash/filter';
import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';
import forEach from 'lodash/forEach';
import orderBy from 'lodash/orderBy';
import map from 'lodash/map';
import slice from 'lodash/slice';
import { useIntl } from 'react-intl';

import { OrderTypes } from '../../constants/orderTypes';

export default function HotelCardTopHotels({ orders, reservations }) {
  const { messages } = useIntl();

  const hotelsList = useMemo(() => {
    if (!(orders.length && reservations.length)) return [];

    const hotelReservations = filter(reservations, (reservation) => {
      const orderExists = !isUndefined(
        find(orders, (order) => {
          return order.id === reservation.refs.orderId;
        })
      );

      return reservation.type === OrderTypes.HOTEL && orderExists;
    });

    let hotelsList = {};
    forEach(hotelReservations, (reservation) => {
      const hotelId = reservation.hotelDetails.hotelId;

      hotelsList[hotelId] = {
        ...reservation.hotelDetails.hotel,
        ...hotelsList[hotelId],
      };

      hotelsList[hotelId].qtd = isUndefined(hotelsList[hotelId].qtd)
        ? 1
        : hotelsList[hotelId].qtd + 1;

      const nights = moment(
        reservation.hotelDetails.checkOut,
        'DD/MM/YYYY'
      ).diff(moment(reservation.hotelDetails.checkIn, 'DD/MM/YYYY'), 'days');

      hotelsList[hotelId].nights = isUndefined(hotelsList[hotelId].nights)
        ? nights
        : hotelsList[hotelId].nights + nights;
    });

    return slice(orderBy(hotelsList, 'qtd', ['desc']), 0, 5);
  }, [orders, reservations]);

  return (
    <CardBody>
      <Row>
        <Colxx sm="12">
          {map(hotelsList, (hotel) => {
            return (
              <div
                key={hotel.iterpec}
                className="d-flex flex-row mb-3 pb-3 justify-content-between align-items-center"
              >
                <div
                  className="hotel-image"
                  style={{ backgroundImage: `url(${hotel.mainPhoto})` }}
                />
                <div className="flex-fill pl-2">
                  <p className="font-weight-medium mb-0">{hotel.name}</p>
                  <p className="text-muted mb-0 text-small">
                    {hotel.destination.city.pt}
                  </p>
                </div>
                <div className="pr-2">
                  {hotel.qtd} {messages['general.reservations']}
                </div>
                <div className="pl-2">
                  {hotel.nights} {messages['general.nights']}
                </div>
              </div>
            );
          })}
        </Colxx>
      </Row>
    </CardBody>
  );
}
